export const HEX_COLOR_REGEXP = /^#([A-F0-9]{3,4}|[A-F0-9]{6}|[A-F0-9]{8})$/i;
export const PASSWORD_REGEXP =
	/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
export const FOUR_WORDS_ONLY_REGEXP = /^(?!.*[—\n\t])([\wа-яА-ЯёЁіІїЇґҐ]+(\s+|$)){0,4}$/
export const PHONE_UA_REGEXP = /^\+38\d{10}$/
